import 'css-chunksrc/client/pages/costProfilesPage/resource/assignCostProfileToResource/styles.scss';export default {
  "assignCostProfileToResource": "_assignCostProfileToResource_1l3hm_1",
  "list": "_list_1l3hm_10"
};